import React, { Fragment } from 'react';
import classNames from 'classnames';

import Hashtag from '../../SvgIcons/Hashtag';
import Cash from '../../SvgIcons/Cash';
import Calendar from '../../SvgIcons/CalendarDay';
import GeoPin from '../../SvgIcons/GeoPin';
import Link from '../../SvgIcons/Link';

/**
 * different types of SVG icons that can be added onto an input field
 */
export enum InputFieldAddOnType {
  HASHTAG = 'hashtag',
  CASH = 'cash',
  CALENDAR = 'calendar',
  GEO_PIN = 'geopin',
  LINK = 'link',
  COUPLE_SEARCH = 'coupleSearch',
  SEARCH = 'search',
  AT = 'at',
}

export interface InputFieldAddOnProps {
  type?: InputFieldAddOnType | null;
}

/**
 * Component to generate an Svg Icon as a prefixed add-on to an input field.
 *
 * This is not meant to be used by clients.  Its an internal component.
 *
 */
const InputFieldAddOn = (props: InputFieldAddOnProps): React.ReactElement => {
  const { type } = props;

  let height = 16;
  let width = 16;
  let Component = null;

  switch (type) {
    case InputFieldAddOnType.HASHTAG: {
      Component = Hashtag;
      break;
    }
    case InputFieldAddOnType.CASH: {
      Component = Cash;
      break;
    }
    case InputFieldAddOnType.CALENDAR: {
      Component = Calendar;
      height = 18;
      width = 18;
      break;
    }
    case InputFieldAddOnType.GEO_PIN: {
      Component = GeoPin;
      height = 14;
      width = 14;
      break;
    }
    case InputFieldAddOnType.LINK: {
      Component = Link;
      break;
    }

    // InputFieldV2 doesn't support AT.  Sorry, not Sorry. Upgrade

    default: {
      Component = null;
    }
  }

  if (Component) {
    return (
      <div className={classNames('input-addon', `input-addon-${type}`)}>
        <div className="input-addon-icon">
          <Component
            className={classNames('form-field__icon addon', type)}
            width={width}
            height={height}
            title={`${type}-icon`}
          />
        </div>
      </div>
    );
  }
  return <Fragment />;
};
export default InputFieldAddOn;
